import { EcoaInput } from "@components/common/EcoaInput";
import React, { useEffect, useState } from "react";
import { CrfTextItemSpec } from "maven-lib/dist/consts/edc";
import { convertToTextFormat, validateTextFormat } from "maven-lib/dist/consts/edc/lib";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";
import { ecoaCrfApi } from "maven-lib/dist/states/apis/ecoaCrf";
import { HbDivider } from "@maven-surface/components/base/HbDivider";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { HbRequestButton } from "@maven-surface/components/base/HbRequestButton";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface QuestionnaireAccountNumberItemProps {
  questionnaire: EcoaQuestionnaire;
  item: CrfTextItemSpec;
  defaultItemValues?: Array<{ itemId: string | null; dbVal: string | number | null }>;
  capturedItems?: Array<{ itemId: string | null; dbVal: string | number | null }>;
  onValueChange: (values: Array<{ itemId: string | null; dbVal: string | number | null }>) => void;
  disabled?: boolean;
  onChangeDisabledFooter: (val: boolean) => void;
}

// TODO: 금융기관 정보 가져오는 api 추가
export function QuestionnaireAccountNumberItem({
  item,
  onValueChange,
  defaultItemValues,
  capturedItems,
  disabled,
  onChangeDisabledFooter,
}: QuestionnaireAccountNumberItemProps) {
  const dbVal = defaultItemValues?.find((val) => val.itemId === item.id)?.dbVal || null;
  const [name, setName] = useState<string | number | null>("");
  const [isDoneValidAccount, setIsDoneValidAccount] = useState<boolean>(!!capturedItems?.find((val) => val.itemId === item.id)?.dbVal);

  const handleValueChange = (value: number | string | null, ev?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (ev && item?.format) {
      const convertedValue = convertToTextFormat(ev.currentTarget.value, item.format);
      const [isCorrected] = validateTextFormat(convertedValue, { ...item.format, disableQuery: undefined });
      return isCorrected && onValueChange([{ itemId: item.id, dbVal: convertedValue }]);
    }
    onValueChange([{ itemId: item.id, dbVal: value }]);
  };

  useEffect(() => {
    onChangeDisabledFooter(!isDoneValidAccount);
  }, [isDoneValidAccount, onChangeDisabledFooter]);

  const getValidateBankAccountParams = () => ({
    bankingVenderType: "popbill",
    accountInfoPayload: {
      bankCode: defaultItemValues?.find((val) => val.itemId === item.extra?.relatedInfo)?.dbVal || "",
      accountNumber: dbVal,
      accountName: name,
    },
  });

  const isTypedAll = !!(defaultItemValues?.find((val) => val.itemId === item.extra?.relatedInfo)?.dbVal && dbVal && name);

  return (
    <>
      <EcoaInput
        disabled={disabled || isDoneValidAccount}
        placeholder={item.placeholder ?? MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_PLACEHOLDER_ENTER_TEXT)}
        onValueChange={handleValueChange}
        defaultVal={dbVal}
      />
      <HbDivider />
      <HbParagraph text={"예금자명"} size="3X-LARGE" bold={true} color="GRAY" />
      <HbDivider />
      <EcoaInput disabled={disabled} placeholder={"이름을 입력해 주세요."} onValueChange={setName} defaultVal={name} />
      <HbRequestButton
        disabled={!isTypedAll || isDoneValidAccount}
        color="PRIMARY"
        api={{
          ...ecoaCrfApi.validateBankingAccount,
          data: getValidateBankAccountParams(),
        }}
        text="계좌 인증"
        confirm={{
          confirmHeader: "계좌 인증",
          confirmMessage: "본인 명의의 계좌정보가 맞습니까?",
          confirmText: "예",
          cancelText: "아니오",
        }}
        delegate={{
          success: (resp) => {
            if (resp.result) {
              setIsDoneValidAccount(true);
              return "계좌 인증 완료 되었습니다.";
            }
          },
          error: (error) => {
            console.error(error.message);
            return "계좌 인증 실패하였습니다.";
          },
        }}
      />
    </>
  );
}
